<div dialog-header>
  <h4>Request Credentials</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

<form [formGroup]="requestForm">
  <div class="request-account-row">
    <app-input-control formControlName="firstName" [alphaOnly]="true" label="First Name" />
    <app-input-control formControlName="lastName" [alphaOnly]="true" label="Last Name" />
  </div>

  <div class="request-account-row">
    <app-input-control formControlName="title" [alphaOnly]="true" label="Title" />
    <app-input-control formControlName="phone" [onlyNumbers]="true" label="Phone" [maxLength]="10" />
  </div>

  <div class="request-account-row">
    <app-input-control formControlName="email" label="Email" />
  </div>

  <div class="request-account-row">
    <app-input-control formControlName="dealer" label="Dealer Number" />

    <div class="dealer-decode-block">
      <div>
        @if (searching()) {
          <app-spinner />
        } @else {
          @if (dealerDecoded()) {
            <app-icon
              width="32px"
              height="32px"
              [ngClass]="searchSuccess() ? 'success' : 'failure'"
              [name]="searchSuccess() ? 'circle_checkmark' : 'circle_warning'"
            />
          }
        }
      </div>
      <button ui-button type="info" (click)="verifyDealer()">Verify</button>
      <button ui-button type="danger" (click)="resetDealer()">Reset</button>
    </div>
  </div>
  @if (requestForm.get('dealer') && requestForm.get('dealerInfo')) {
    <div class="dealer-info-block" formGroupName="dealerInfo">
      <app-input-control formControlName="dealerName" label="Dealer Name" />
      <app-input-control formControlName="dealerAddress1" label="Dealer Address" />
      <div class="request-account-row">
        <app-input-control formControlName="dealerZipCode" label="Dealer Zip" />
        <app-input-control formControlName="dealerCity" label="Dealer City" />
        <app-input-control formControlName="dealerState" label="Dealer State" />
      </div>
    </div>
  }

  <app-recaptcha (resolved)="onCaptchaResolved($event)" />
</form>

@if (emailSuccess()) {
  <p class="success-text">Your request has been sent!</p>
}

<div dialog-actions>
  @if (!emailSuccess()) {
    <button ui-button (click)="requestAccount()" [disabled]="!(requestForm.valid && searchSuccess())">Submit</button>
    <button ui-button type="danger" (click)="close()">Cancel</button>
  } @else {
    <button ui-button (click)="close()">Continue</button>
  }
</div>
